// extracted by mini-css-extract-plugin
module.exports = {"block":"PaymentsUsage_block__CJAry","currency":"PaymentsUsage_currency__NCEKr"};